export interface IDeviceAccumulatedEventDto {
    lat: string;
    lng: string;
    timestamp: string;
    eventType: string;
    eventData?: string;
    metadata?: {
        zoneExternalId?: string;
        duration?: number;
        minSpeed?: number;
        maxSpeed?: number;
    };
}

export interface IDeviceEventsWithDevicesResponse {
    devices: {
        deviceId: number;
        deviceExternalId?: string;
        events: IDeviceAccumulatedEventDto[];
    }[];
}
